// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.store-addons-for-woocommerce-navbar .navbar-nav .nav-item .dropdown .dropdown-menu {
  position: relative;
}/*# sourceMappingURL=HorizontalMenuControl.css.map */`, "",{"version":3,"sources":["webpack://./src/components/HorizontalMenuControl/HorizontalMenuControl.scss","webpack://./src/components/HorizontalMenuControl/HorizontalMenuControl.css"],"names":[],"mappings":"AAIgB;EACI,kBAAA;ACHpB,CAAA,oDAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
